module.exports = __webpack_public_path__ + "static/media/fish-cooked.5eccec02.svg";